import { createTheme } from '@mui/material/styles';

// Color palette inspired by the weather app UI
const purpleTheme = {
  primary: {
    main: '#6a49db', // Brighter purple
    light: '#BB98E8', // Light purple
    dark: '#4f38c3', // Dark purple
  },
  secondary: {
    main: '#29292a', // Dark background
    light: '#2d2d2d', // Slightly lighter background
  },
  gray: {
    light: '#aba8a8', // Light gray for text
    main: '#777', // Medium gray
    dark: '#555', // Dark gray
  },
};

// Create theme instances
export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: purpleTheme.primary.main,
      light: purpleTheme.primary.light,
      dark: purpleTheme.primary.dark,
    },
    secondary: {
      main: purpleTheme.secondary.main,
    },
    background: {
      default: '#f8f9fa',
      paper: '#ffffff',
      card: '#ffffff',
    },
    text: {
      primary: '#212121',
      secondary: purpleTheme.gray.dark,
      accent: purpleTheme.primary.main,
    },
  },
  typography: {
    fontFamily: "'Kanit', 'Product Sans', sans-serif",
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 700,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: purpleTheme.primary.main,
      light: purpleTheme.primary.light,
      dark: purpleTheme.primary.dark,
    },
    secondary: {
      main: purpleTheme.secondary.main,
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
      card: '#252525',
    },
    text: {
      primary: '#ffffff',
      secondary: '#aba8a8',
      accent: purpleTheme.primary.light,
    },
  },
  typography: {
    fontFamily: "'Kanit', 'Product Sans', sans-serif",
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 700,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
  },
}); 